import styled from "styled-components";
import theme from "../../../styles/theme";

/**
 * Telas de entrada (login, admin, esqueci/redefinir senha), redesign V3 fase 3.
 * O mesmo markup de antes (.left-item / .right-item): a esquerda vira o painel
 * azul da marca, a direita o cartão do formulário.
 */
export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 0;
  width: 100%;
  padding: 24px 16px;
  box-sizing: border-box;
  background: var(--bg);
`;

export const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
  color: black;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 400px minmax(0, 1fr);
  width: min(92vw, 1040px);
  min-height: 560px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 28px rgba(31, 35, 41, 0.06);

  .left-item {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 14px;
    padding: 44px 44px 36px;
    box-sizing: border-box;
    color: #ffffff;
    background: linear-gradient(180deg, #1a62cc 0%, #0f4aa6 55%, #0a3a8c 100%);
    overflow: hidden;

    /* faixa com as cores do Google, como no logo */
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(
        90deg,
        #fbbc04 0 25%,
        #34a853 25% 50%,
        #ea4335 50% 75%,
        #4285f4 75% 100%
      );
    }
    /* barras do gráfico ao fundo */
    &::after {
      content: "";
      position: absolute;
      left: 160px;
      bottom: -40px;
      width: 300px;
      height: 230px;
      opacity: 0.1;
      background:
        linear-gradient(#fff, #fff) 0 100% / 90px 170px no-repeat,
        linear-gradient(#fff, #fff) 104px 100% / 90px 230px no-repeat,
        linear-gradient(#fff, #fff) 208px 100% / 90px 130px no-repeat;
      border-radius: 18px;
      pointer-events: none;
    }

    .left-image {
      position: relative;
      width: 180px;
      padding: 10px 14px;
      border-radius: 14px;
      background: #ffffff;
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
      margin-bottom: 18px;
      box-sizing: border-box;
    }
    .left-title {
      position: relative;
      font-family: var(--font-sans);
      font-size: 28px;
      line-height: 34px;
      font-weight: 700;
      letter-spacing: -0.3px;
      max-width: 300px;
    }
    .left-subtitle {
      position: relative;
      font-family: var(--font-sans);
      font-size: 15px;
      line-height: 24px;
      color: rgba(255, 255, 255, 0.86);
      max-width: 300px;
      white-space: normal;
    }
  }

  .right-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    gap: 18px;
    padding: 48px;
    box-sizing: border-box;
    max-width: 496px;
    width: 100%;
    margin: 0 auto;
  }

  @media (${theme.devices.tablet}) {
    grid-template-columns: 1fr;
    width: min(94vw, 520px);
    min-height: auto;
    .left-item {
      padding: 28px 24px 24px;
      gap: 8px;
      &::after {
        display: none;
      }
      .left-image {
        width: 150px;
        margin-bottom: 8px;
      }
      .left-title {
        font-size: 22px;
        line-height: 28px;
      }
      .left-subtitle {
        font-size: 14px;
        line-height: 20px;
      }
    }
    .right-item {
      padding: 24px 20px 28px;
      gap: 16px;
    }
  }
`;

export const InputContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const RegisterInputContainer = styled(InputContainer)`
  flex-direction: column;
  width: 100%;
  row-gap: 14px;
`;

export const BtnsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  width: 100%;

  /* os botões e links vêm dentro de um wrapper das páginas */
  & > div {
    width: 100%;
    align-items: stretch !important;
  }

  a,
  .link {
    font-family: var(--font-sans);
    font-size: 14px;
    font-weight: 500;
    color: var(--brand);
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;
  justify-content: center;
  padding: 12px 16px 20px;
  box-sizing: border-box;
  background: var(--bg);

  a {
    font-family: var(--font-sans);
    font-size: 13px;
    color: var(--text-muted);
    text-decoration: none;
    cursor: pointer;
    &:hover {
      color: var(--brand);
      text-decoration: underline;
    }
  }
`;
